import { Code, Brain, Palette, Database, Smartphone } from 'lucide-react';
import { Course } from '../types';

export const courses: Course[] = [
  {
    id: 1,
    title: "Complete Web Development Masterclass",
    instructor: "Rahul Sharma",
    rating: 4.8,
    reviews: 8234,
    students: 45678,
    price: 4999,
    originalPrice: 12999,
    duration: "52h",
    level: "Beginner to Advanced",
    category: "Web Development",
    gradient: "from-blue-600 via-blue-500 to-cyan-500",
    icon: Code,
    imageUrl: "https://images.unsplash.com/photo-1542831371-29b0f74f9713?w=800&auto=format&fit=crop&q=60",
    enrolled: false,
    progress: 0,
    modules: 18,
    bestseller: true,
    language: "Hindi + English",
    lastUpdated: "Oct 2024"
  },
  {
    id: 2,
    title: "AI & Machine Learning Full Course",
    instructor: "Dr. Priya Verma",
    rating: 4.9,
    reviews: 6543,
    students: 32456,
    price: 5999,
    originalPrice: 14999,
    duration: "68h",
    level: "Intermediate",
    category: "Data Science",
    gradient: "from-purple-600 via-purple-500 to-pink-500",
    icon: Brain,
    imageUrl: "https://images.unsplash.com/photo-1555255707-c07969078f46?w=800&auto=format&fit=crop&q=60",
    enrolled: false,
    progress: 0,
    modules: 22,
    bestseller: true,
    language: "Hindi + English",
    lastUpdated: "Nov 2024"
  },
  {
    id: 3,
    title: "UI/UX Design Pro Bootcamp",
    instructor: "Anjali Kapoor",
    rating: 4.7,
    reviews: 4321,
    students: 28934,
    price: 3999,
    originalPrice: 9999,
    duration: "38h",
    level: "Beginner",
    category: "Design",
    gradient: "from-pink-600 via-rose-500 to-orange-500",
    icon: Palette,
    imageUrl: "https://images.unsplash.com/photo-1581291518857-4e27b48ff24e?w=800&auto=format&fit=crop&q=60",
    enrolled: false,
    progress: 0,
    modules: 14,
    bestseller: true,
    language: "Hindi",
    lastUpdated: "Oct 2024"
  },
  {
    id: 4,
    title: "Full Stack JavaScript Development",
    instructor: "Arjun Singh",
    rating: 4.8,
    reviews: 5678,
    students: 34567,
    price: 4499,
    originalPrice: 11999,
    duration: "45h",
    level: "Advanced",
    category: "Web Development",
    gradient: "from-green-600 via-emerald-500 to-teal-500",
    icon: Code,
    imageUrl: "https://images.unsplash.com/photo-1627398242454-45a1465c2479?w=800&auto=format&fit=crop&q=60",
    enrolled: false,
    progress: 0,
    modules: 16,
    bestseller: false,
    language: "English"
  },
  {
    id: 5,
    title: "Cloud Computing with AWS & Azure",
    instructor: "Vikram Patel",
    rating: 4.6,
    reviews: 3456,
    students: 23456,
    price: 6999,
    originalPrice: 16999,
    duration: "55h",
    level: "Advanced",
    category: "Cloud Computing",
    gradient: "from-orange-600 via-amber-500 to-yellow-500",
    icon: Database,
    imageUrl: "https://images.unsplash.com/photo-1573164713988-8665fc963095?w=800&auto=format&fit=crop&q=60",
    enrolled: false,
    progress: 0,
    modules: 20,
    bestseller: false,
    language: "Hindi + English"
  },
  {
    id: 6,
    title: "Android App Development Masterclass",
    instructor: "Sneha Reddy",
    rating: 4.7,
    reviews: 4567,
    students: 31234,
    price: 4799,
    originalPrice: 12499,
    duration: "48h",
    level: "Intermediate",
    category: "Mobile Development",
    gradient: "from-indigo-600 via-blue-500 to-purple-500",
    icon: Smartphone,
    imageUrl: "https://images.unsplash.com/photo-1607252650355-f7fd0460ccdb?w=800&auto=format&fit=crop&q=60",
    enrolled: false,
    progress: 0,
    modules: 17,
    bestseller: false,
    language: "English"
  }
];
